import { Step as ModelStep } from "@redotech/redo-model/return-flow";
import { waitFromModel } from "@redotech/redo-model/return-flow-step-from-model";
import {
  isWaitStepValid,
  WaitState,
} from "@redotech/redo-model/return-flow-step-valid";
import { BlockLayout } from "@redotech/redo-web/flowchart";
import WaitIcon from "@redotech/redo-web/icon-old/wait.svg";
import { produce } from "immer";
import * as React from "react";
import { StepDownstream, StepType, StepTypeDetailsProps } from "../step";

export const WAIT = (
  Details: React.ComponentType<StepTypeDetailsProps<WaitState>>,
): StepType<WaitState, ModelStep.Wait> => ({
  Details: (props: StepTypeDetailsProps<WaitState>) =>
    React.createElement(Details, props),
  customTitle(state) {
    return state.customTitle;
  },
  title: "Wait",
  valid(state) {
    return isWaitStepValid(state).valid;
  },
  Icon: WaitIcon,
  description(state) {
    return `${state.numDays} day${state.numDays !== 1 ? "s" : ""}`;
  },
  empty: { numDays: 0, next: undefined },
  downstream(state) {
    const result: StepDownstream[] = [];
    if (state.next !== undefined) {
      result.push({ id: state.next });
    }
    return result;
  },
  maxDownstream() {
    return 1;
  },
  stepDeleted(state, stepId) {
    return produce(state, (state) => {
      if (state.next === stepId) {
        state.next = undefined;
      }
    });
  },
  updateConnection(state, handleIndex, targetStepId) {
    if (handleIndex !== 0) {
      throw new Error(`Invalid handle index ${handleIndex} for Wait step`);
    }
    return produce(state, (draft) => {
      draft.next = targetStepId;
    });
  },
  removeConnection(state, targetStepId) {
    return produce(state, (draft) => {
      if (draft.next === targetStepId) {
        draft.next = undefined;
      }
    });
  },
  layout() {
    return BlockLayout.FULL;
  },
  toModel(state, id) {
    return {
      customTitle: state.customTitle,
      type: ModelStep.WAIT,
      numDays: state.numDays,
      next: id(state.next!),
    };
  },
  fromModel(model, id) {
    return waitFromModel(model, id);
  },
});

export { type WaitState } from "@redotech/redo-model/return-flow-step-valid";
